import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../../../types.ts';

export const selectCommentary = (state: RootState) => state.commentary;

export const selectCommentaryV2 = createSelector(
  selectCommentary,
  ({
    marketConditionsV2,
    priorSales,
    siteExtraction,
    depreciatedCost,
    reconciliation,
    alerts,
  }) => ({
    marketConditionsV2,
    priorSales,
    siteExtraction,
    depreciatedCost,
    reconciliation,
    alerts,
  }),
);
